import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SvgIcon } from 'components/SvgIcon';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import { enPixelPath, pixelService } from 'services/PixelService';

export default class BoletoCod extends BaseComponent<any>{
  constructor(props: any) {
    super(props);
    this.focusTextInput = this.focusTextInput.bind(this);
    this.state = { visibilityTooltip: false, textInput: '', tooltipMessage: 'Copiar' };
  }

  focusTextInput = (event: any) => {
    event.preventDefault();
    this.state.textInput.focus();
    this.state.textInput.setSelectionRange(0, 9999);
    document.execCommand('Copy');
    pixelService.track(enPixelPath.BANKSLIP);
    this.setState({ visibilityTooltip: true, tooltipMessage: 'Copiado!' });
    setTimeout(() => this.setState({ visibilityTooltip: false, tooltipMessage: 'Copiar' }), 1500);
  }

  setTextInputValue = (input: any) => {
    this.setState({ textInput: input });
  }

  render() {

    if (!this.props.cod) {
      return null;
    }

    return (
      <div style={{ width: '100%' }}>
        <label className='chk-lbl-boleto-cod'>CÓDIGO DO BOLETO</label>
        <div className={`chk-input-copy ${this.props.isButton ? '' : 'column'}`}>
          <TextField
            inputRef={this.setTextInputValue}
            value={this.props.cod}
            id='boleto-cod'
            className={'chk-boleto-input'}
            InputProps={{
              startAdornment: <InputAdornment position='start'><SvgIcon name={'boleto'} /></InputAdornment>,
              readOnly: true
            }}
          />
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            placement='top'
            open={this.state.visibilityTooltip}
            disableFocusListener
            disableHoverListener
            title={this.state.tooltipMessage}
          >
            {this.props.isButton ?
              <button id='chk-copy-button' onClick={this.focusTextInput}> Copiar </button> :
              <p id='chk-copycode-button' onClick={this.focusTextInput}>Copiar código do Boleto</p>
            }
          </Tooltip>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoPage/BoletoCod/index.tsx